import {assert} from 'Asserts';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isStepSucceeded} from 'pipelines/PipelineStepStatusUtils';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {AnalysisLayoutStatus, AnalysisLayoutStatusInfo, LayoutStep} from './AnalysisAdapterTypes';
import {resolveReference} from './AnalysisAdapterUtils';

export default function getAnalysisLayoutStatusInfo(
  analysis: PipelineGraphQL,
  layoutStep: LayoutStep
): AnalysisLayoutStatusInfo {
  if (isStepSucceeded(layoutStep.statusCode) || layoutStep.statusCode === PipelineStepStatusCode.HALTED) {
    return {status: AnalysisLayoutStatus.READY};
  }

  if (layoutStep.config == null) {
    return {
      status: AnalysisLayoutStatus.FAILED,
      message: 'We ran into an issue displaying this layout.',
      reason: 'Please contact Benchling Support for help.',
    };
  }

  for (const statusDependency of layoutStep.config.statusDependencies ?? []) {
    for (const parentReference of statusDependency?.inputReferences ?? []) {
      const parentStep = resolveReference(parentReference, layoutStep, analysis);
      const parentStatus = parentStep.statusCode;

      if (parentStatus === PipelineStepStatusCode.FAILED) {
        return {
          status: AnalysisLayoutStatus.FAILED,
          message: statusDependency.failureMessage,
          reason: parentStep.statusMessage!,
        };
      } else if (
        parentStatus === PipelineStepStatusCode.BLOCKED ||
        parentStatus === PipelineStepStatusCode.WAITING ||
        parentStatus === PipelineStepStatusCode.RUNNING ||
        parentStatus === PipelineStepStatusCode.AI_PROPOSED
      ) {
        return {status: AnalysisLayoutStatus.RUNNING, message: statusDependency.runningMessage};
      } else {
        assert(
          isStepSucceeded(parentStatus) || parentStatus === PipelineStepStatusCode.HALTED,
          `Unknown status code: ${parentStatus}`
        );
      }
    }
  }

  return {status: AnalysisLayoutStatus.READY};
}
